import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable,Subject } from 'rxjs';
import { CreateFolderRequest, CreateNonClientFolderRequest, TemplateUploadRequest, UploadRequest, CopyMoveModel, DmsEditFilesModel, SearchCriteriaRequest, AttachDocumentList, DocumentDuplicateResult } from '../Models/dmsModel';
import { CustomGridViewService } from './shared/custom-grid-view.service';
import { attachTaskList } from '../Models/auditModel';
import { dmsHelperCommon } from './dmsHelperCommon';
import { debounceTime,distinctUntilChanged } from 'rxjs/operators';
import { FeatureFlagService } from '../commonservice/featureflag.service';
import { DeleteFolderRequest } from '../Models/SharePointPracticeModel';

@Injectable({
    providedIn: 'root'
})

export class DmsService extends dmsHelperCommon {
    private headers: HttpHeaders;
    private subject: Subject<string> = new Subject<string>();

    constructor(
        private http: HttpClient,
        private stateManagement: CustomGridViewService,
        private featureFlagService: FeatureFlagService
    ) {
        super();
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
    }

    emitValue(value: string) {
        this.subject.next(value);
    }

    getDebouncedValue(debounceTimeMs: number = 1500): Observable<string> {
        return this.subject.asObservable().pipe(
            debounceTime(debounceTimeMs),
            distinctUntilChanged()
        );
    }

    GetSharePointSites() {
        return this.http.get<any>(`api/datams/GetSharePointSites`, { headers: this.headers });
    }
    GetDocumentSites(siteId: any, siteType: any, folderId: any = null) {
        const url = `api/datams/GetClientNonClientSite/${siteId}/${siteType}`;
        let params = new HttpParams()
            .set('siteId', siteId)
            .set('siteType', siteType);
        if (folderId !== null) {
            params = params.set('folderId', folderId);
        }
        return this.http.get<any>(url, { params, headers: this.headers });
    }

    getClientDetailsByClientId(accountingFirmId:number, userId:string, clientId:string) {
        const params = new HttpParams()
        .set('accountingFirmId', accountingFirmId)
        .set('userId', userId)
        .set('clientId', clientId);

    const url = 'api/datams/GetClientDetailsforOutlook';
    return this.http.get<any>(url, { headers: this.headers, params });
    }

    RetryClientFolderCreation(siteId: any) {
        const url = `api/datams/RetryClientFolderCreation/${siteId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }
    getAllFolders(siteId: any, clientId: any) {
        const url = `api/datams/GetClientFolderStructure/${siteId}/${clientId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    getClientsByClientID(clientId: any) {
        const url = `api/datams/GetClientDetails/${clientId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    GetAllDocument(folderId: any) {
        const url = `api/datams/GetDocument/${folderId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    getPreviewURL(driveId: any, driveItemId: any) {
        const url = `api/datams/GetPreviewURL/${driveId}/${driveItemId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    GetOpenInBrowser(driveId: any, driveItemId: any) {
        const url = `api/datams/GetOpenInBrowser/${driveId}/${driveItemId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    DownloadDoc(driveId: any, driveItemId: any) {
        const url = `api/datams/DownloadDocument/${driveId}/${driveItemId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    OpenDesktopApp(driveId: any, driveItemId: any) {
        const url = `api/datams/OpenDesktop/${driveId}/${driveItemId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    getClientList() {
        const url = `api/datams/GetClientList`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    getMetaDataFields(SiteId: number) {
        const url = `api/datams/GetMetaDataFields/${SiteId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    uploadDocuments(request: UploadRequest): Observable<any> {
        const formData: FormData = new FormData();
        formData.append('MetadataValues', request.metadataValues);
        formData.append('ClientId', request.clientId.toString());
        formData.append('FolderId', request.folderId);
        formData.append('SiteId', request.siteId.toString());
        formData.append('ConflictAction', request.conflictAction.toString());

        request.files.forEach((file, index) => {
            formData.append('Files', file, file.name);
        });
        const url = `api/datams/SPUpload`;
        return this.http.post<any>(url, formData);
    }

    uploadClientJobDocuments(request: UploadRequest): Observable<any> {
        const formData: FormData = new FormData();
        formData.append('MetadataValues', request.metadataValues);
        formData.append('ClientId', request.clientId.toString());
        formData.append('FolderId', request.folderId);
        formData.append('SiteId', request.siteId.toString());
        formData.append('ContextType', request.contextType.toString());
        request.files.forEach((file, index) => {
            formData.append('Files', file, file.name);
        });
        const url = `Outlook/SPUploadforOutlook`;
        return this.http.post<any>(url, formData);
    }

    getDocumentDetailsByFolderId(folderId:string) {
        const params = new HttpParams()
        .set('folderId', folderId)
        .set('accountingFirmId', 0)
        .set('userId', "");
        const url = `api/datams/GetDocumentDetailsByFolderId`;
        return this.http.get<any>(url, {headers: this.headers, params});
    }

    getSearchClients(siteId: any, searchText: any, folderId: any, clientId: any) {
        const url = `api/datams/Search`;
        let params = new HttpParams()
            .set('siteId', siteId)
            .set('searchText', searchText)
            .set('folderId', folderId)
            .set('clientId', clientId);

        return this.http.get<any>(url, { params, headers: this.headers });
    }


    CreateChildFolder(request: CreateFolderRequest): Observable<any> {
        const url = `api/datams/CreateChildFolder`;
        return this.http.post<any>(url, request);
    }

    CreateNonClientFolder(request: CreateNonClientFolderRequest): Observable<any> {
        const url = `api/datams/CreateNonClientFolder`;
        return this.http.post<any>(url, request);
    }

    GetBreadcrumbs(folderId: any) {
        const url = `api/datams/GetFileBreadcrumbs`;
        let params = new HttpParams()
            .set('folderId', folderId)
        return this.http.get<any>(url, { params, headers: this.headers });
    }

    GetShareList(siteId: any, driveId: any, driveItemId: any, linkType: any) {
        const url = `api/datams/CreateShareLink/${siteId}/${driveId}/${driveItemId}/${linkType}`;
        return this.http.get<any>(url);
    }

    GetClientDocumentLinks(clientId: any, folderId: any) {
        const url = `api/datams/GetClientDocumentLinks/${clientId}/${folderId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }



    GetMetaDataFieldsByfirmId(siteId, folderId, documentId) {
        const url = `api/datams/GetMetaDataFieldsByfirmId/${siteId}/${folderId}/${documentId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    UpdateMetadataProperties(request: DmsEditFilesModel): Observable<any> {
        const url = `api/datams/UpdateMetadataProperties`;
        return this.http.post<any>(url, request);
    }

    bulkUpdateMetadataProperties(payload: any): Observable<any> {
        const url = `api/datams/BulkUpdateMetadataProperties`;
        return this.http.post<any>(url, payload);
    }

    GetKCClientDocument(clientId: any, folderId: any) {
        const url = `api/datams/GetClientDocumentLinks/${clientId}/${folderId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    copyDocument(request: CopyMoveModel): Observable<any> {
        const url = `api/datams/CopyDocument`;
        return this.http.post<any>(url, request);
    }

    moveDocument(request: CopyMoveModel): Observable<any> {
        const url = `api/datams/MoveDocument`;
        return this.http.post<any>(url, request);
    }

    GetActivity(driveId: any, driveItemId: any) {
        const url = `api/datams/GetActivity/${driveId}/${driveItemId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }
    GetBreadcrumHomeData(clientId: any) {
        const url = `api/datams/GetBreadcrumHomeData/${clientId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }
    GetVersionHistory(driveId: any, driveItemId: any, documentId: any) {
        const url = `api/datams/GetVersionHistory/${driveId}/${driveItemId}/${documentId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }
    AddEditGridCustomView(formPosted) {
        return this.http.post<any>('api/datams/AddEditGridCustomView', formPosted, { headers: this.headers });
    }
    GetCustomGridViewList(screenName, viewId = 0) {
        if (this.stateManagement.getCustomGridView.value == null) {
            return this.GetCustomGridViewById(viewId, screenName);
        } else {
            return this.stateManagement.getCustomGridView;
        }
    }
    GetCustomGridViewById(viewId: number, screenName: string) {
        return this.http.get<any>(`api/datams/GetCustomViewList`, {
            params: {
                id: viewId,
                screenName: screenName
            }
        });
    }
    DeleteGridCustomViewById(viewId) {
        return this.http.post<any>('api/datams/DeleteGridCustomViewById?id=', viewId, { headers: this.headers });
    }
    GetUserPermission(siteId: number) {
        const url = `api/datamssiterole/GetUserPermission/${siteId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    CreateClientChildFolder(createClientChildFolderRequest) {
        return this.http.post<any>('api/datams/CreateClientChildFolder', createClientChildFolderRequest);
    }

    GetClientGroupList() {
        const path = `api/datams/GetClientGroupListByFirmId`; // No clientId in the URL
        const url = path;
        return this.http.get<any>(url, { headers: this.headers });
    }

    getSearchClientsWithCriteria(searchText: any, searchCriteriaRequest: SearchCriteriaRequest, requestPagePayload: any) {
        const url = `api/datams/SearchWithCriteria?searchText=${searchText}&searchCriteriaRequest=${encodeURIComponent(JSON.stringify(searchCriteriaRequest))}&requestPagePayload=${encodeURIComponent(JSON.stringify(requestPagePayload))}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    getClientListWithGroupCodes() {
        const url = `api/datams/GetClientListWithGroupCodes`;
        return this.http.get<any>(url, { headers: this.headers });
    }
    GetClientNameByDocId(docId: any) {
        const url = `api/datamstask/GetClientName/${docId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    GetJibNmaeList(clientId: number) {
        const url = `api/datamstask/GetJobNameList/${clientId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }
    GetTaskGroupList(jobId) {
        const url = `api/datamstask/GetTaskGroupNameList/${jobId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }
    GetTaskTypeList() {
        const url = `api/datamstask/GetTaskTypeNameList`;
        return this.http.get<any>(url, { headers: this.headers });
    }
    GetUserList() {
        const url = `api/datamstask/GetUserList`;
        return this.http.get<any>(url, { headers: this.headers });
    }
    GetStatusList() {
        const url = `api/datamstask/GetTaskStatusList`;
        return this.http.get<any>(url, { headers: this.headers });
    }
    saveTask(task: any): Observable<any> {
        const url = `api/datamstask/CreateTask`;
        return this.http.post<any>(url, task);
    }
    GetDocListBytaskId(taskId: number, activityId: number) {
        const url = `api/datams/GetDocListByTaskId`;
        return this.http.get<any>(url, {
            params: {
                taskId: taskId.toString(), // Convert to string if necessary
                activityId: activityId.toString() // Send activityId as a query parameter
            },
            headers: this.headers // Optional, if you need headers
        });
    }
    attachDocuments(docList: AttachDocumentList[]): Observable<any> {
        const url = `api/datamstask/Attach`
        return this.http.post<any>(url, docList, { headers: this.headers });
    }
    DeleteAttachedDoc(Id: string) {
        // Define the query params using HttpParams
        let params = new HttpParams().set('id', Id);

        // Pass the query parameters using the 'params' option
        return this.http.post<any>('api/datamstask/DeleteAttachedFile', null, {
            params: params,
            headers: this.headers
        });
    }
    GetTaskListByDocId(docId) {
        const url = `api/datamstask/GetTaskListByDId/${docId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }
    GetTaskDetailById(taskId: number, type: string) {
        const url = `api/datamstask/GetTaskDetailsById/${taskId}/${type}`;
        return this.http.get<any>(url, { headers: this.headers });
    }
    getListOfAllTasksByClientId(clientId: number, documentId: any): Observable<any> {
        const url = `api/datams/GetListOfAllTasksByClientId/${clientId}/${documentId}`;
        return this.http.get<any>(url);
    }
    attachTaskList(taskList: attachTaskList[]): Observable<any> {
        const url = `api/datams/AttachTasksList`
        return this.http.post<any>(url, taskList, { headers: this.headers });
    }

    documentDel(documentDeleteRequests: any) {
        const url = `api/datams/DocumentDelete`;
        return this.http.post<any>(url, documentDeleteRequests, { headers: this.headers });
    }

    GetSPTemplates() {
        const url = `api/datams/GetSPTemplates`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    uploadTemplate(request: TemplateUploadRequest, accountingFirmId = 0, userId: string | null = null, spUser = 'User'): Observable<any> {
        const formData = new FormData();

        // ✅ Check if files exist before appending
        if (request.files && request.files.length > 0) {
            request.files.forEach((file) => {
                formData.append('Files', file, file.name);
            });
        } else {
            // Optionally: Return an error or continue without files
            formData.append('Files', new Blob(), 'empty.txt'); // Prevent API errors by sending an empty file
        }

        // Append other form fields
        formData.append('MetadataValues', request.metadataValues || '');
        formData.append('ClientId', request.clientId.toString());
        formData.append('FolderId', request.folderId || '');
        formData.append('SiteId', request.siteId.toString());

        if (request.driveId) formData.append('DriveId', request.driveId);
        if (request.driveItemId) formData.append('DriveItemId', request.driveItemId);
        if (request.fileTemplateName) formData.append('FileTemplateName', request.fileTemplateName);
        if (request.documentAction) formData.append('DocumentAction', request.documentAction);
        // Set headers
        let headers = new HttpHeaders();
        headers = headers.append('AccountingFirmId', accountingFirmId.toString());
        if (userId) headers = headers.append('UserId', userId);
        headers = headers.append('SPUser', spUser);

        const apiUrl = `api/datams/SPUploadTemplate`;
        return this.http.post<any>(apiUrl, formData);
    }

    GetClientDocumentFolderLocation(clientId: any, folderId: any) {
        const url = `api/datams/folderlocation/${clientId}/${folderId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    GetMoveCopyItemList(folderId: any) {
        const url = `api/datams/GetMoveCopyItemList/${folderId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }
    GetSPClientListData(siteID: number) {
        const url = `api/datams/GetSPClientListData/${siteID}`;
        return this.http.get<any>(url, { headers: this.headers });
    }
    moveDocuments(requests: CopyMoveModel[]): Observable<any> {
        const url = `api/datams/MoveItems`;
        return this.http.post<any>(url, requests, { headers: this.headers });
    }
    copyDocuments(request: CopyMoveModel[]): Observable<any> {
        const url = `api/datams/CopyItems`;
        return this.http.post<any>(url, request);
    }
    moveFolders(requests: CopyMoveModel[]): Observable<any> {
        const url = `api/datams/MoveFolders`;
        return this.http.post<any>(url, requests, { headers: this.headers });
    }
    copyFolders(requests: CopyMoveModel[]): Observable<any> {
        const url = `api/datams/CopyFolders`;
        return this.http.post<any>(url, requests, { headers: this.headers });
    }

    getMetadataDependencyMappings(SiteId: number) {
        const url = `api/datams/GetMetadataDependencyMappings/${SiteId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    saveDependencyMappings(data: any[]): Observable<any> {
        const url = `api/datams/MetadataDependencySave`;
        return this.http.post<any>(url, data, { headers: this.headers });
    }

    getMetadataDependencyMappingOnParentID(SiteId: number, ParentMetaDataId: number) {
        const url = `api/datams/GetMetadataDependencyMappingOnParentID/${SiteId}/${ParentMetaDataId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    GetRequestFiles(siteId, folderId, message, receiverEmailList) {
        return this.http.get<any>(`api/datams/CreateRequestFilesLink/${siteId}/${folderId}`, {
            params: {
                message: message,
                toEmailReciver: receiverEmailList
            }
        });
    }

    async isFeatureEnabled(flagKey: string, fallback = false): Promise<boolean> {
        try {
            return await this.featureFlagService.getAccountingFirmFeatureFlag(flagKey);
        } catch (error) {
            return fallback;
        }
    }

    SyncToOneDrive(folderId: any) {
        const url = `api/datams/SyncToOneDrive/${folderId}`;        
        return this.http.post<any>(url, {}, { headers: this.headers });
    }

    RemoveFromOneDrive(data_OneDriveItemId: any) {
        const url = `api/datams/RemoveFromOneDrive/${data_OneDriveItemId}`;        
        return this.http.post<any>(url, {}, { headers: this.headers });
    }

    checkDuplicateFiles(folderId: string, fileNames: string[]) {
        return this.http.post<DocumentDuplicateResult[]>(
            'api/datams/check-duplicate',
            {
                folderId,
                fileNames
            }
        );
    }

    bulkDownloadDocuments(docs: any[]): Observable<HttpResponse<Blob>> {
        return this.http.post(
        'api/datams/DownloadDocumentsZip',
        docs,
        {
            responseType: 'blob',
            observe: 'response'
        }
        );
    }

    downloadDocuments$(requests: any[]) {
        return this.bulkDownloadDocuments(requests);
    }   
    
    openInOutlookOnline(driveId: string, driveItemId: string) {
        return this.http.get<any>(
            `api/datams/OpenInOutlookOnline/${driveId}/${driveItemId}`
        );
    }

    getClientSiteDocuments(siteId: any) {
        const url = `api/datams/GetClientListSite/${siteId}`;
        return this.http.get<any>(url);
    }

    advancedSearchWithCriteria(payload: any): Observable<any> {
        const url = `api/datams/AdvancedSearchWithCriteria`;
        return this.http.post<any>(url, payload, { headers: this.headers });
    }

    getRecipientsOfClients(clientIds: string) {
        const params = new HttpParams().set('clientIds', clientIds);

        return this.http.get<any>(
            'Client/GetRecipientsOfClients',
            { params }
        );
    }

    getFolders(clientIds: string) {
        const params = new HttpParams().set('clientIds', clientIds);

        return this.http.get<any>(
            'api/datams/GetFolders',
            { params }
        );
    }

    getDmsTemplates() {
        const url = `api/DMSTemplate/GetDmsTemplates`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    downloadTemplates(payload: any): Observable<any> {
        const url = `api/DMSTemplate/generate-Template`;

        return this.http.post(url, payload, {
            headers: this.headers,
            observe: 'response',
            responseType: 'blob'
        });
    }

    uploadDocumentsSettings(payload: any): Observable<any> {
        const url = `api/DMSTemplate/dms-upload`;
        return this.http.post<any>(url, payload, { headers: this.headers });
    }

    deleteTemplates(payload: any): Observable<any> {
        const url = `api/DMSTemplate/dms-delete`;
        return this.http.post<any>(url, payload, { headers: this.headers });
    }

    getDMSClientList(clientStatus: string, groupCode: string | null): Observable<any> {
        const params = new HttpParams()
            .set('clientStatus', clientStatus);
        if (groupCode !== null) {
            params.set('groupCode', groupCode);
        }
        const url = 'api/DMSTemplate/GetDMSClientList';
        return this.http.get<any>(url, { headers: this.headers, params });
    }

    uploadNewVersion(payload: any): Observable<any> {
        const url = `api/DMSTemplate/upload-new-version`;
        return this.http.post<any>(url, payload, { headers: this.headers });
    }

    getFYFolderListForClientRootFolder(rootFolderId: string) {
        const url = `api/datams/GetFinancialYearOptions?parentId=${rootFolderId}`;
        return this.http.get<any>(url, { headers: this.headers });
    }

    getFolderDetails(payload: any) {
        const url = `api/datams/GetFolderDetails`;
        return this.http.post<any>(url, payload, { headers: this.headers });
    }

    getFullDocumentSearchItems(payload: any) {
        const url = `api/datams/SearchSharePointItems`;
        return this.http.post<any>(url, payload, { headers: this.headers });
    }

    deleteFolder(payload: DeleteFolderRequest[]): Observable<any> {
        const url = `api/datams/HardFolderDelete`;
        return this.http.post<any>(url, payload, { headers: this.headers });
    }

    deleteDocumentFolder(payload: any): Observable<any> {
        const url = `api/DMSTemplate/dms-delete-folder`;
        return this.http.post<any>(url, payload, { headers: this.headers });
    }
}
